<igo-draw
  [stores]="stores"
  [map]="map"
  (layersIDEvent)="addLayersID($event)"
  [activeDrawingLayer]="activeDrawingLayer"
  [drawControls]="drawControls"
  (drawControlsEvent)="addDrawControls($event)"
  (activeLayerChange)="activeDrawingLayer = $event"
/>
